// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"fcc2357d","448":"4c161efd","536":"47a38553"}[chunkId] + ".chunk.css";
};